<div class="sw-pagination">
  @if (itemsTemplate) {
    <div class="sw-pagination-size">
      <p class="text-mm margin-inline-16">Items per page</p>
      <ng-container *ngTemplateOutlet="itemsTemplate"></ng-container>
    </div>
  }
  <div class="sw-pagination-pages">
    @if (showNumberText) {
      <p class="text-mm margin-inline-16">
        {{ start() }} - {{ end() }} of {{ total }}
      </p>
    }
    <!-- <button class="sw-btn sw-btn-md sw-btn-icon-only"
        >
      <i class="sds-arrow-left padding-16"></i>
    </button> -->
    <div
      class="page-number-wrapper"
      [class.margin-inline-2]="!showInput"
      [class.center]="alignItems && alignItems === 'center'"
      [class.left]="alignItems && alignItems === 'left'"
      [class.right]="alignItems && alignItems === 'right'"
    >
      @if (showInput) {
        <ul>
          <li class="previous" [class.disable]="previousDisabled()">
            <a
              aria-label="Previous"
              [ngClass]="buttonStyle"
              (click)="previous()"
              >Previous</a
            >
          </li>
          @for (num of pageNumbers; track num; let idx = $index) {
            <li
              (click)="pagenumberClick(num)"
              class="page-number-button"
              [class.active]="page === num"
            >
              <a>{{ num }}</a>
            </li>
          }
          <li class="next" [class.disable]="nextDisabled()">
            <a
              aria-label="Previous"
              [ngClass]="{
                'sw-btn-gray': !nextDisabled(),
              }"
              [ngClass]="buttonStyle"
              (click)="next()"
              >Next</a
            >
          </li>
        </ul>
      }
    </div>
  </div>
</div>
